/**
 * ISO-ish week bucket for rolling “this week” upvote ladders (Monday-based UTC week numbering).
 */
export function isoWeekBucketId(dateInput: Date = new Date()): string {
  const calendarDate = new Date(Date.UTC(dateInput.getFullYear(), dateInput.getMonth(), dateInput.getDate()))
  const dayNum = calendarDate.getUTCDay() || 7
  calendarDate.setUTCDate(calendarDate.getUTCDate() + 4 - dayNum)
  const yearStart = new Date(Date.UTC(calendarDate.getUTCFullYear(), 0, 1))
  const weekNumber =
    Math.ceil((((calendarDate.getTime() - yearStart.getTime()) / 86400000) + 1) / 7) || 1
  const weekPart = weekNumber <= 99 ? String(weekNumber).padStart(2, '0') : String(weekNumber)
  return `${calendarDate.getUTCFullYear()}-W${weekPart}`
}

/**
 * Short human time-ago string used inside post + comment headers.
 * Single character unit avoids translation gymnastics in MVP.
 */
export function formatShortTimeAgo(date: Date): string {
  const seconds = Math.max(1, Math.round((Date.now() - date.getTime()) / 1000))
  if (seconds < 60) return `${seconds}s`
  const minutes = Math.round(seconds / 60)
  if (minutes < 60) return `${minutes}m`
  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${hours}h`
  const days = Math.round(hours / 24)
  if (days < 7) return `${days}d`
  const weeks = Math.round(days / 7)
  if (weeks < 5) return `${weeks}w`
  const months = Math.round(days / 30)
  if (months < 12) return `${months}mo`
  return `${Math.round(days / 365)}y`
}
